import pierrePhoto from "./assets/images/pierre.png";
import robertPhoto from "./assets/images/robert.png";

export default Object.freeze([
  Object.freeze({
    key: "pierre",
    photo: pierrePhoto,
    color: "var(--color-accent-500)",
    embed:
      "https://edlib.digisprong.be/content/01kv52jpygwqj20my2ecgch8jb/embed",
  }),
  Object.freeze({
    key: "robert",
    photo: robertPhoto,
    color: "var(--color-primary-500)",
    embed:
      "https://edlib.digisprong.be/content/01m31ztvrtc5pnsawpcbn33j0v/embed",
  }),
]);
